import GrayButton from "../../components/GrayButton";
import {useAppContext} from "../../context/AppContext";

export default function SelectionInfo({type, ...props}) {
    const {selection, resolveSelectionSide} = useAppContext()
    const side = resolveSelectionSide(selection?.[type]) || {}

    const getSurvey = () => {
        if(side.survey?.title) {
            return `(${side.survey?.title})`;
        }

        return ''
    }

    return (
        <GrayButton
            {...props}
            style={{
                fontSize: '14pt',
                width: '100%',
                marginBottom: 16,
                height: 40,
            }}
        >
            <b style={{marginRight: 4}}>
                {side.project?.modelType && `[${side.project?.modelType}] `}
                {side.project?.information?.title?.trim()}:
            </b>{' '}
            {side.plan?.type}{' '}
            {side.river && `, ${side.river?.river} - ${side.river?.reach}`}
            {'  '}{getSurvey()}
        </GrayButton>
    )
}
